import { render, staticRenderFns } from "./style-test-transition.vue?vue&type=template&id=37ae2fe7&scoped=true&"
import script from "./style-test-transition.vue?vue&type=script&lang=js&"
export * from "./style-test-transition.vue?vue&type=script&lang=js&"
import style0 from "./style-test-transition.vue?vue&type=style&index=0&id=37ae2fe7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ae2fe7",
  null
  
)

export default component.exports